(() => {
  'use strict';

  const selectors = [
    'img[data-mb-loose-cover]',
    '#product-grid .card__media img',
    '.mb-page-content a[href*="/products/"] img',
    '.mb-fund-list-card__image img',
    '.mb-gift-result-card a[href*="/products/"] img',
    '.mb-product-slide__image img',
  ].join(',');

  const candidates = (root = document) => {
    const images = [];
    if (root.matches?.(selectors)) images.push(root);
    root.querySelectorAll?.(selectors).forEach((image) => images.push(image));
    return images;
  };

  const fit = (image) => {
    const frame = image.closest('.mb-loose-cover-frame');
    const host = frame?.parentElement;
    if (!frame || !host || !image.naturalWidth || !image.naturalHeight) return;

    const sourceRatio = image.naturalWidth / image.naturalHeight;
    const cropStart = sourceRatio < 1.55 ? 0 : sourceRatio >= 2.1 ? 0.4 : 0.5;
    const coverRatio = sourceRatio * (1 - cropStart);
    const availableWidth = Math.max(1, host.clientWidth - 8);
    const availableHeight = Math.max(1, host.clientHeight - 8);

    /*
     * MatchBoox bronbeelden hebben dezelfde fysieke productschaal: links het
     * zwarte doosje en rechts een staande of liggende cover. Schaal daarom niet
     * iedere uitsnede afzonderlijk tot de grenzen van het kader. Dan wordt een
     * staande cover groter dan een liggende cover en verandert ook de denkbeeldige
     * grootte van het doosje. Eén gedeelde schaal, gebaseerd op de breedste
     * liggende cover (3:2), houdt staand en liggend exact in dezelfde verhouding.
     */
    const widestCoverRatio = 1.5;
    const scale = Math.min(availableWidth / widestCoverRatio, availableHeight);

    frame.style.setProperty('--mb-loose-frame-width', `${Math.round(coverRatio * scale * 100) / 100}px`);
    frame.style.setProperty('--mb-loose-frame-height', `${Math.round(scale * 100) / 100}px`);
    image.style.setProperty('--mb-loose-source-width', `${Math.round(sourceRatio * scale * 100) / 100}px`);
    image.style.setProperty('--mb-loose-source-height', `${Math.round(scale * 100) / 100}px`);
  };

  const prepare = (image) => {
    if (!(image instanceof HTMLImageElement)) return;
    if (image.closest('.mb-home .mb-fund-gallery')) return;
    // De cadeaukiezer toont al de volledige tweede Shopify-productafbeelding.
    // Laat deze kaarten daarom buiten de uitsnede-/schaallogica hieronder:
    // die kan worden aangeroepen voordat de resultaatcarrousel breed is en
    // zou dan een gemeten formaat van circa 1px vastzetten.
    if (image.closest('.mb-gift-results-stage')) return;

    let frame = image.closest('.mb-loose-cover-frame');
    if (!frame) {
      const parent = image.parentElement;
      if (!parent) return;
      const host = document.createElement('span');
      host.className = 'mb-loose-cover-host';
      frame = document.createElement('span');
      frame.className = 'mb-loose-cover-frame';
      parent.insertBefore(host, image);
      host.appendChild(frame);
      frame.appendChild(image);
    }

    if (image.dataset.mbLooseCoverReady !== 'true') {
      image.dataset.mbLooseCoverReady = 'true';
      image.addEventListener('load', () => fit(image));
      const host = frame.parentElement;
      if ('ResizeObserver' in window && host) {
        const observer = new ResizeObserver(() => fit(image));
        observer.observe(host);
      }
    }
    if (image.complete) fit(image);
  };

  const enhance = (root = document) => candidates(root).forEach(prepare);

  const init = () => {
    enhance();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) enhance(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
